import { render } from "./Menu.vue?vue&type=template&id=0cc242dc&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=0cc242dc&scoped=true&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=0cc242dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc242dc"]])

export default __exports__